<ul class="breadcrumb">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/entities']">Configuración</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/provinces']">Provincias</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li [hidden]="province.id==null"><a [routerLink]="['/configuration/provinces', province.id]">{{province.name}}</a></li>
    <li [hidden]="province.id!=null">Nueva provincia</li>
</ul>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>
<form #formDetails="ngForm">
    <p-card header="Detalles">
        <div class="p-grid">
            <div class="p-col-6 p-field">
                <label for="name">Nombre</label>
                <input name="name" type="text" pInputText [(ngModel)]="province.name" required />
            </div>
            <div class="p-col-6 p-field">
                <label for="country">País</label>
                <p-dropdown name="country" [options]="countries" optionLabel="name" optionValue="id" [(ngModel)]="province.country_id" placeholder="Selecciona país" required></p-dropdown>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <div class="p-d-flex">
                <p-button label="Borrar" icon="pi pi-trash" styleClass="p-button-danger"
                    (click)="delete()" *ngIf="province.id!=null"></p-button>
                <div class="flex-grow-1"></div>
                <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary p-button-text"
                    (click)="cancel()"></p-button>
                <p-button label="Guardar" icon="pi pi-check" styleClass="p-ml-2" (click)="isDuplied()"></p-button>
            </div>
        </ng-template>
    </p-card>
</form>
